























import { Component, Vue } from 'vue-property-decorator'
import { downloadState } from '../../store/modules/DownloadState'
import {
  Anchor,
  AnchorConditions
} from '../../modules/class/PdfDownload/Conditions'

@Component
export default class PdfDownloadTableAnchor extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // data

  // 抽出条件（main.tsから連携される）
  private conditions: AnchorConditions = new AnchorConditions()

  // --------------------------------------------------------------------------------------------------------------------
  // computed

  /**
   * 表示しているテーブルのアンカーリンクを取得
   */
  get anchorSet(): string[] {
    return downloadState.anchorList
  }

  get showLinks(): Anchor[] {
    const links: Anchor[] = []
    let isOptional: boolean;
    isOptional = true;

    // 表示しているテーブルのアンカーリンク情報を取得
    for (const anchor of this.conditions.anchors) {
      if (this.anchorSet.includes(anchor.id)) {
        anchor.optional = false;
        links.push(anchor)
        isOptional = false;
      }
    }

    // ユーザ指定のリンク情報を取得
    for (const link of this.conditions.links) {
      if (link.optional){
        links.push(link)
      }
    }

    // ユーザ指定のリンク登録がない場合
    if (!isOptional){
      // テーブルを表示して、moreボタンが存在する場合
      // 対象にmoreボタンを追加
      if (this.conditions.hasMore && links.length > 0) {
        const more = this.conditions.more
        if (more) {
          more.optional = false;
          links.push(more)
        }
        this.showElements('.js-showMore')
      }

      if (links.length > 0) {
        this.showElements('.js-showAnchor')
      }
    }

    return links
  }

  /**
   * テーブルが表示されたと判定し、
   * 連動する項目を表示状態にする
   */
  private showElements(selector: string) {
    const nodeList = document.querySelectorAll(selector)
    if (nodeList.length > 0) {
      nodeList.forEach((node) => {
        const element = node as HTMLElement
        element.style.display = 'block'
      })
    }
  }
}
